import { createFileRoute } from "@tanstack/react-router"
import { BackofficeFlags } from "modules/backoffice/components/flags"
import { GetBackofficeFlagsConversationsSchema } from "schema"
import { z } from "zod"

const BackofficeFlagsSearchSchema = GetBackofficeFlagsConversationsSchema

function RouteComponent() {
  const search = Route.useSearch()
  const navigate = Route.useNavigate()

  return (
    <BackofficeFlags
      search={search}
      routeFullPath={Route.fullPath}
      onFilterByChange={(filterBy) =>
        navigate({ search: (prev) => ({ ...prev, page: 1, filterBy }) })
      }
      onTimeFrameChange={(timeFrame) =>
        navigate({ search: (prev) => ({ ...prev, page: 1, timeFrame }) })
      }
    />
  )
}

export const Route = createFileRoute("/_base/_auth/backoffice/flags/")({
  component: RouteComponent,
  validateSearch: (search: Partial<z.input<typeof BackofficeFlagsSearchSchema>>) =>
    BackofficeFlagsSearchSchema.parse(search),
})
